/**
 * @generated SignedSource<<7fc1e2c51f14630235b9b403a4aa70fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerPreQuotedOption_shipmentQuote$data = {
  readonly serviceId: string | null;
  readonly serviceMethod: {
    readonly serviceMethodType: string | null;
    readonly serviceType: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDescription_shipmentQuote" | "PreQuoteDutiesDescription_shipmentQuote" | "PreQuoteTitle_shipmentQuote" | "PreloadedCheckoutDuties_shipmentQuote">;
  readonly " $fragmentType": "BuyerPreQuotedOption_shipmentQuote";
};
export type BuyerPreQuotedOption_shipmentQuote$key = {
  readonly " $data"?: BuyerPreQuotedOption_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOption_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerPreQuotedOption_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteDescription_shipmentQuote"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_shipmentQuote"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreloadedCheckoutDuties_shipmentQuote"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteDutiesDescription_shipmentQuote"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceMethodType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "5e2280fba8f9817538d4d5774ed61bd1";

export default node;
